const NAME = "SNACKBAR";

export default NAME;
